/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/application_flow/application_flow';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "ListApplicationFlowsRequest": {
                "fields": {
                  "state": {
                    "type": ".squareup.corporate_card.resources.application_flow.ApplicationFlow.State",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListApplicationFlowsResponse": {
                "fields": {
                  "applicationFlows": {
                    "type": ".squareup.corporate_card.resources.application_flow.ApplicationFlow",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ListApplicationFlowsRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ListApplicationFlowsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ListApplicationFlowsRequest @ squareup/corporate_card/service/list_application_flows.proto at 9:1
 */
export const ListApplicationFlowsRequest = $root.lookupType('squareup.corporate_card.service.ListApplicationFlowsRequest');
fixType(ListApplicationFlowsRequest);
Builder.createAndAttachToType(ListApplicationFlowsRequest);
/**
 * SOURCE ListApplicationFlowsResponse @ squareup/corporate_card/service/list_application_flows.proto at 16:1
 */
export const ListApplicationFlowsResponse = $root.lookupType('squareup.corporate_card.service.ListApplicationFlowsResponse');
fixType(ListApplicationFlowsResponse);
Builder.createAndAttachToType(ListApplicationFlowsResponse);